<template>
  <div class="progress-card">
    <RexProgressCard
      :headerName="diskUtility"
      :headerLegends="headerLegends"
      :items="diskData"
      :loading="loading"
      :progressTailLabelColor="progressTailLabelColor"
      :colorInfo="colorInfo"
    />
  </div>
</template>
<script>
import RexProgressCard from '@/rex-components/RexProgressCard.vue';
import { metricMongoDBTypes } from '@/components/Database/database.types';
import { mapActions, mapState, mapGetters } from 'vuex';
import { headerLegends } from '@/utils/templates/databaseTemplate/cards.config';

export default {
  components: {
    RexProgressCard,
  },
  data() {
    return {
      diskUtility: this.$t('dbm.header.diskUtility'),
      progressTailLabelColor: false,
      colorInfo: false,
      diskData: [],
      loading: false,
      headerLegends: [],
    };
  },
  created() {
    this.headerLegends = headerLegends;
    this.getDiskData();
  },
  computed: {
    ...mapState('databaseState/detail', [
      'currentDatabaseInstance',
      'currentSubType',
    ]),
    ...mapState('databaseState/databaseCommonState', [
      'currentDatabaseType',
      'currentDatabaseService',
    ]),
    ...mapGetters('globalState/settings', ['getDurationTime', 'intervalTime']),
  },
  methods: {
    ...mapActions('databaseState/databaseCommonState', ['GET_DB_DISK_DATA']),
    async getDiskData() {
      this.loading = true;
      try {
        if (this.currentDatabaseInstance?.key) {
          this.diskData = await this.GET_DB_DISK_DATA({
            serviceId: this.currentDatabaseService?.key,
            duration: this.getDurationTime,
            endpointName: this.currentDatabaseInstance?.key,
            scope: 'Endpoint',
            usedMetricName: metricMongoDBTypes.METER_MONGO_DISK_SIZE_USED,
            totalMetricName: metricMongoDBTypes.METER_MONGO_DISK_SIZE_TOTAL,
          });
          this.diskData.forEach((item) => {
            item.used.textValue = this.$t('dbm.usedMemory');
            item.total.textValue = this.$t('dbm.totalMemory');
            item.available.textValue = this.$t('dbm.availableMemory');
          });
          this.colorInfo = true;
        } else {
          this.diskData = [];
          this.colorInfo = false;
        }
      } catch (error) {
        this.diskData = [];
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    getDurationTime() {
      this.getDiskData();
    },
    currentDatabaseInstance() {
      this.getDiskData();
    },
  },
};
</script>
<style lang="scss" scoped>
.progress-card {
  height: 100%;
}
</style>
